// @flow
import { createSelector } from 'reselect';
import map from 'ramda/es/map';
import prop from 'ramda/es/prop';
import pipe from 'ramda/es/pipe';

import { sortByTitle } from 'app/common/lib/sort';


type ApiProduct = {
  id: number,
  name: string,
  slug: string,
  url: string,
  category: {
    slug: string,
    name: string,
  },
  master: {
    id: number,
    sku: string,
    name: string,
    price: string,
    compare_at_price: string,
    image: {
      id: number,
      product_id: number,
      is_default: true,
      name: string,
      asset: {
        url: string,
        thumb: {
          url: string,
        },
        standart: {
          url: string,
        },
        high: {
          url: string,
        }
      },
      position: number,
      file_size: number,
      content_type: 'image/png',
      created_at: string,
      updated_at: string,
    },
  },
}

// $FlowFixMe
const selectCategories = createSelector(
  state => state.shop.catalog.products.data,
  pipe(
    map(({
      id,
      slug,
      url,
      name,
      master,
    }: ApiProduct) => ({
      id,
      slug,
      title: name,
      imgSrc: url,
      price: prop('price', master),
    })),
    sortByTitle,
  ),
);

export default selectCategories;
